import {httpsCallable} from 'firebase/functions';
import {functions} from '../Security/firebase-config';

export async function requestLinkedDeletion(payload) {
  const response = await httpsCallable(functions, 'linkedDeletionV2', {timeout: 540000})(payload);
  return response.data;
}
export function linkedDeletionErrorMessage(error) {
  if (['functions/internal', 'functions/unavailable', 'functions/not-found'].includes(error?.code) || error?.message === 'internal') {
    return 'The linked-item deletion service is unavailable. Check your connection and try again shortly.';
  }
  return error?.message || 'Could not load linked items. Please try again.';
}
export function initialDeletionSelection(plan, anchor, seedVideoIds = []) {
  return {
    videoIds: anchor.kind === 'vod' ? plan.videos.filter(row => row.canDelete && (!seedVideoIds.length || seedVideoIds.includes(row.id.split('/').at(-1)))).map(row => row.id) : [],
    focusIds: [],
    statsIds: anchor.kind === 'stats' ? plan.stats.filter(row => row.canDelete && row.id.split('/').at(-1) === anchor.statsId).map(row => row.id) : [],
    calendarIds: [],
  };
}
export function deletionSummary(plan, selection) {
  const automaticNotes = plan.notes.filter(group => group.videoIds.every(id => selection.videoIds.includes(id)));
  const focus = plan.focusGroups.filter(row => selection.focusIds.includes(row.id));
  const entire = plan.videos.every(row => selection.videoIds.includes(row.id)) && plan.focusGroups.every(row => selection.focusIds.includes(row.id)) && plan.stats.every(row => selection.statsIds.includes(row.id));
  return {
    videos: selection.videoIds.length, stats: selection.statsIds.length,
    notes: automaticNotes.reduce((n, row) => n + row.count, 0),
    attachments: automaticNotes.reduce((n, row) => n + row.attachments, 0),
    notesCleanup: automaticNotes.length > 0,
    focus: focus.reduce((n, row) => n + row.count, 0),
    ratings: focus.reduce((n, row) => n + row.ratings, 0),
    entire,
    hasSelection: Object.values(selection).some(ids => ids.length),
  };
}
